import { FormFieldProps } from "../../../../utils/types/inputTypes";

export const serviceDefinitionFields: FormFieldProps[] = [
  {
    type: "autoComplete",
    label: "Typ produktu",
    name: "type",
    disabled: true,
    optionsKey: "productTypeOptions",
  },
  {
    type: "autoComplete",
    label: "Název obchodního partnera",
    name: "invBusPartnerIn",
    optionsKey: "invBusPartnerOptions",
    placeHolder: "Zadejte",
  },
  {
    type: "autoComplete",
    label: "Název služby / produktu",
    name: "serviceIn",
    optionsKey: "servicesAndContractsOptions",
    placeHolder: "Zadejte",
    required: true,
  },
];
